function getRandomInt (min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export function shuffle (arr) {
  let _arr = arr.slice()
  for (let i = 0; i < _arr.length; i++) {
    let j = getRandomInt(0, i)
    let t = _arr[i]
    _arr[i] = _arr[j]
    _arr[j] = t
  }
  return _arr
}

export function debounce (func, delay) {
  let timer

  return function (...args) {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

export function isWechatClient () {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}

// 获取url中的参数
export function getQueryString (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i') // 匹配目标参数
  var result = window.location.search.substr(1).match(reg) // 对querystring匹配目标参数
  if (result != null) {
    return decodeURIComponent(result[2])
  } else {
    return null
  }
}

// 获取卡券显示名称
export function getItemTitle (item) {
  if (item.type == 1) {
    if (item.isAssignCompany == 0) {
      let count = item.toCompanylist.length
      if (count > 1) {
        return count + '店通用体验券'
      } else {
        return item.toCompanylist[0].shortname + '体验券'
      }
    } else if (item.isAssignCompany == 1) {
      return '平台通用体验券'
    } else if (item.isAssignCompany == 2) {
      return item.shortname + '体验券'
    }
  } else if (item.type == 2) {
    return item.shortname + '抵用券'
  } else if (item.type == 3) {
    if (item.isAssignCompany == 0) {
      let count = item.toCompanylist.length
      if (count > 1) {
        return count + '店通用定向券'
      } else {
        return item.toCompanylist[0].shortname + '定向券'
      }
    }
  }
}
// 判断是否是url
export function IsURL (_url) {
  var strRegex = '((https|http|ftp|rtsp|mms)?://)' +
 "(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" +
  '(([0-9]{1,3}\\.){3}[0-9]{1,3}' +
  '|' +
  "([0-9a-z_!~*'()-]+\\.)*" +
  '([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\\.' +
  '[a-z]{2,6})' +
  '(:[0-9]{1,4})?' +
  '((/?)|' +
  "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)"
  var re = new RegExp(strRegex)
  if (re.test(_url)) {
    return (true)
  } else {
    return (false)
  }
}
// 格式化JSON字符串 如果不是JSON字符串则原样返回
export function formatJson (str) {
  if (typeof str == 'string') {
    try {
      let obj = JSON.parse(str)
      if (typeof obj == 'object' && obj) {
        return obj
      } else {
        return str
      }
    } catch (e) {
      console.log('error：' + str + '!!!' + e)
      return str
    }
  }
}
// 设置默认头像
export function getAvatarOrDefault (avatarUrl) {
  if (avatarUrl) {
    return avatarUrl
  } else {
    return require('../../assets/avatar.png')
  }
}



// WEBPACK FOOTER //
// ./src/common/js/util.js